import { createAction, props } from '@ngrx/store';
import {
  ScheduleInterface,
  ScheduleOptions,
} from '@fc-core/models/operator-schedule.model';

export const loadVehicleSchedules = createAction(
  '[VehicleSchedule] Load VehicleSchedules',
  props<{ options: ScheduleOptions }>(),
);

export const loadVehicleSchedulesSuccess = createAction(
  '[VehicleSchedule] Load VehicleSchedules Success',
  props<{ eventList: ScheduleInterface[] }>(),
);

export const addVehicleSchedule = createAction(
  '[VehicleSchedule] Add VehicleSchedules',
  props<{ event: ScheduleInterface }>(),
);

export const addVehicleScheduleSuccess = createAction(
  '[VehicleSchedule] Add VehicleSchedules Success',
  props<{ event: ScheduleInterface }>(),
);

export const deleteVehicleSchedule = createAction(
  '[VehicleSchedule] Delete VehicleSchedules',
  props<{ event: ScheduleInterface }>(),
);

export const deleteVehicleScheduleSuccess = createAction(
  '[VehicleSchedule] Delete VehicleSchedules Success',
  props<{ event: ScheduleInterface }>(),
);

export const updateVehicleSchedule = createAction(
  '[VehicleSchedule] Update VehicleSchedules',
  props<{ event: ScheduleInterface }>(),
);

export const updateVehicleScheduleSuccess = createAction(
  '[VehicleSchedule] Update VehicleSchedules Success',
  props<{ event: ScheduleInterface }>(),
);

export const vehicleSchedulesError = createAction(
  '[VehicleSchedule] Load VehicleSchedules Failure',
  props<{ error: any }>(),
);
